import { createContext } from "react";

export const SideNavContext = createContext({});
